import React from "react";
import { CallToAction } from "../../components";
import ScrollButton from "../../components/ScrollButton/ScrollButton";
import About from "../About/About";
import Blog from "../Blog/Blog";
import Devs from "../Devs/Devs";
import Features from "../Features/Features";
import Header from "../Header/Header";
import Process from "../Process/Process";
import Promotion from "../Promotion/Promotion";

const Home = () => {
  return (
    <>
      <div className="gradient__bg">
        <Header />
      </div>
      <About />
      <Promotion />
      <Features />
      <CallToAction />
      <Blog />
      <Devs />
      <ScrollButton />
    </>
  );
};

export default Home;
